exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Trigger .StandardFieldLayout_Label {\n  min-width: 140px;\n}\n", ""]);

